import React from 'react';
import { WHATSAPP_LINK } from '../data/contactLinks';
import './FloatingWhatsAppButton.css';

export default function FloatingWhatsAppButton() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="floating-whatsapp"
    >
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        className="floating-whatsapp__icon"
      >
        <path d="M20.52 3.48A11.87 11.87 0 0 0 12.07 0C5.52 0 .2 5.3.2 11.84c0 2.09.55 4.14 1.59 5.94L0 24l6.41-1.68a11.9 11.9 0 0 0 5.66 1.45h.01c6.54 0 11.86-5.31 11.86-11.85 0-3.16-1.23-6.13-3.42-8.44Zm-8.45 18.28h-.01a9.9 9.9 0 0 1-5.05-1.39l-.36-.21-3.8 1 1.01-3.7-.24-.38a9.86 9.86 0 0 1-1.52-5.24c0-5.46 4.45-9.9 9.92-9.9 2.65 0 5.14 1.03 7 2.89a9.85 9.85 0 0 1 2.91 7.02c0 5.46-4.45 9.91-9.86 9.91Zm5.44-7.42c-.3-.15-1.77-.87-2.04-.96-.27-.1-.47-.15-.67.14-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.48-.88-.78-1.47-1.74-1.64-2.03-.17-.3-.02-.45.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.06 2.9 1.21 3.1.15.2 2.09 3.19 5.05 4.47.7.3 1.25.48 1.67.62.7.22 1.33.19 1.84.12.56-.08 1.77-.72 2.03-1.42.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35Z" />
      </svg>
    </a>
  );
}
